import { PACKAGED_WORKFLOW } from 'pages/IntegrationManager/data';
import { createSelector } from 'reselect';
import { selectFeatureToggleMap } from 'selectors/navigation/util';

export const getIntegrationType = state =>
  state.workflowCreationWizard.integrationType;

const getIntegration = createSelector(
  [getIntegrationType],
  integrationType => PACKAGED_WORKFLOW[integrationType],
);

export const isWorkflowCreationWizardOpen = state =>
  !!state.workflowCreationWizard.integrationType;

export const shouldUsePackagedWorkflowInstallSelector = createSelector(
  [getIntegration, selectFeatureToggleMap],
  (integration, featureToggleMap) => {
    if (integration) {
      const featureFlag = integration.packagedWorkflowFeatureToggle;
      if (featureFlag) {
        return featureToggleMap[featureFlag] === 'true';
      }
      return true;
    }
    return false;
  },
);

// codelessWorkflows go through the same install process as packagedWorkflows
// but show a different success page upon successfull installation
export const isCodelessBuiltInWorkflow = createSelector(
  [getIntegration],
  integration => integration && integration.codelessBuiltInWorkflow,
);
